/* eslint eslint-comments/no-use: off */
/* eslint-disable @github-ui/github-components/require-component-stories */
import type {RefComparison} from '@github-ui/code-view-types'
import {SyncIcon, TriangleDownIcon} from '@primer/octicons-react'
import {ActionMenu, Button, Octicon} from '@primer/react'

import {useReposAnalytics} from '../../../hooks/use-repos-analytics'
import {FetchPopoverContainer} from './FetchPopoverContainer'
import {PopoverContainer} from './InfobarPopover'

interface Props {
  comparison: RefComparison
}

export function FetchUpstreamButton({comparison}: Props) {
  const {sendRepoClickEvent} = useReposAnalytics()

  return (
    <ActionMenu
      onOpenChange={open =>
        open &&
        sendRepoClickEvent('SYNC_FORK_BUTTON', {
          category: 'Branch Infobar',
          action: 'Open Fetch upstream dropdown',
          label: 'ref_loc:fetch_upstream_dropdown',
          ahead: comparison.ahead,
          behind: comparison.behind,
        })
      }
    >
      <ActionMenu.Anchor>
        <Button leadingVisual={SyncIcon}>
          Sync fork
          <Octicon icon={TriangleDownIcon} sx={{marginLeft: 1}} />
        </Button>
      </ActionMenu.Anchor>
      <ActionMenu.Overlay align="end" sx={{marginTop: 2}}>
        <PopoverContainer>
          <FetchPopoverContainer comparison={comparison} />
        </PopoverContainer>
      </ActionMenu.Overlay>
    </ActionMenu>
  )
}

try{ FetchUpstreamButton.displayName ||= 'FetchUpstreamButton' } catch {}